const PartnerEnum = Object.freeze({
  VISA: 'VISA',
  AMEX: 'AMEX',
  getList: () => [PartnerEnum.VISA, PartnerEnum.AMEX],
});

export default PartnerEnum;
